import { getCurrentFeatureCode } from '../../auth';
import { axiosProvider } from '@/app/core/axios';
import { ClientAttributesApiResponse } from '@ssar-app/domain';
import ms from 'ms';
const getClientAttributes = async (
  subscriberCode: string,
): Promise<ClientAttributesApiResponse> => {
  const response =
    await axiosProvider.apiClient.get<ClientAttributesApiResponse>(
      `/user/client-attributes/for-id?subCode=${encodeURIComponent(
        subscriberCode,
      )}&productName=${encodeURIComponent(getCurrentFeatureCode() || '')}`,
      {
        cache: {
          ttl: ms('1 minute'),
        },
      },
    );
  return response.data;
};

export { getClientAttributes };
